import React from "react";
import { useEffect } from "react";
import AssociatingWithKc from "../PST/Associating";
import ThreeSteps from "../PST/Steps";
import GloballyUniversities from "../PST/Universities";
import { MetaTagsComp } from "../MetaTagsComp";
import CapabilitiesCourseFinder from "../PST/Capabilities";
import AccomplishSection from "../OverseasEdutionFair/AccomplishSection";
import EduFairStudentTestimonials from "../OverseasEdutionFair/eduFairStudTestimonials";
import StudiesFAQ from "../AdmissionsDay/StudiesFAQ";
import GrabChanceSection from "../OverseasEdutionFair/GrabChanceSection";
import PartnerFooter from "../PST/Footer";
import PartnerBannerSection from "../PST/PartnerBanner";
import WhyKC from "../PST/WhyKc";
import RightBussinessDecisionKc from "../PST/RightBussinessDecision";
import ElanLoan from "../PST/ElanLoan";
import RecruitmentPartner from "../PST/RecruitmentPartner";
import EduFairFooterCommon from "../OverseasEdutionFair/eduFairFooter";
import { useRouter } from "next/router";
import FranchiseeModel from "../PST/FranchiseeModel";
import CountryTeam from "./CountryTeam";
interface Props {
  eventData: any;
  countryTeamData?: any;
}


const FranchiseeComponent: React.FC<Props> = ({ eventData, countryTeamData }) => {
  const router = useRouter();
  useEffect(() => {
    const customStyle = document.documentElement.style;
    customStyle.setProperty(
      "--event-bgcolor",
      eventData?.bannerSection?.sectionBgColor || "#6C48F0"
    );
  }, []);

  return (
    <>
      {eventData && <MetaTagsComp {...eventData.meta} />}
      {(eventData.bannerSection || eventData.banerSection) && (
        <div>
          <PartnerBannerSection
            data={eventData.bannerSection || eventData.banerSection}
            jotforms={eventData?.meta?.jotforms}
            externalLink={eventData?.externalLink}
          />
        </div>
      )}
      {eventData?.whyKcSection && (
        <div>
          <WhyKC whykcdata={eventData?.whyKcSection} />
        </div>
      )}

      {eventData?.franchiseeModelSection && (
        <FranchiseeModel franchiseeModelData={eventData?.franchiseeModelSection} />
      )}

      {eventData?.whyChooseKc && (
        <div>
          <RightBussinessDecisionKc
            data={eventData.whyChooseKc}
            jotformId={eventData?.meta?.jotforms[0]?.jotformid}
            externalLink={eventData?.externalLink}
          />
        </div>
      )}
      {eventData?.benefitsSectionCards && (
        <div>
          <AssociatingWithKc
            associatingdata={eventData?.benefitsSectionCards}
            title={eventData?.benefitsSectionTitle}
            subtitle={eventData?.benefitsSectionSubTitle}
            bgcolor={eventData?.benefitsSectionBgColor}
          />
        </div>
      )}
      {eventData?.recruitmentPartner && (
        <RecruitmentPartner eventData={eventData} />
      )}
      {eventData?.tieUpsSection && (
        <div>
          <GloballyUniversities data={eventData?.tieUpsSection} />
        </div>
      )}
      <GrabChanceSection eventData={eventData} />
      {(eventData?.courseFinder || eventData?.coursefinder) && (
        <div>
          <CapabilitiesCourseFinder eventData={eventData} />
        </div>
      )}
      {(eventData?.elanLoans || eventData?.elanloans) && (
        <div>
          <ElanLoan
            data={eventData.elanLoans || eventData.elanloans}
            jotformId={eventData?.meta?.jotforms[0]?.jotformid}
            externalLink={eventData?.externalLink}
            bgColor={
              eventData.elanLoans?.sectionBgColor ||
              eventData.elanloans?.sectionBgColor
            }
          />
        </div>
      )}
      {eventData?.easyStepsSection && (
        <div>
          <ThreeSteps
            data={eventData?.easyStepsSection}
            bgcolor={eventData?.easyStepsSection?.sectionBgColor}
          />
        </div>
      )}
      <AccomplishSection eventData={eventData} />
      {eventData?.studentsSaySection && (
        <div>
          <EduFairStudentTestimonials data={eventData?.studentsSaySection} />
        </div>
      )}
      {
        (countryTeamData?.length > 0 && (countryTeamData[0]?.countrySalesManagers?.managerCard?.length > 0  || countryTeamData[0].regionalManagers?.managerCard?.length > 0)) && (
          <div>
            <CountryTeam countryTeamData={countryTeamData[0]} />
          </div>
        )
      }
      {eventData?.faqSection && (
        <div>
          <StudiesFAQ faqdata={eventData?.faqSection} />
        </div>
      )}
      
      {eventData?.footerSection && (
        <>
          {router.asPath.includes('recruiter/') && !router.asPath.includes('become-overseas-education-recruiter') ? (
            <div>
              <EduFairFooterCommon data={eventData?.footerSection} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink}/>
            </div>
          ) : (
            (router.asPath.includes('recruiter/') || router.asPath.includes('franchisee/') || router.asPath.includes('/partners/study-abroad-recruiter')) && !router.asPath.includes('/partners/study-abroad-recruiter-in') && (
              <div>
                <PartnerFooter
                  data={eventData?.footerSection}
                  jotformId={eventData?.meta?.jotforms[0]?.jotformid}
                  externalLink={eventData?.externalLink}
                />
              </div>
            )
          )}
        </>
       )}
    </>
  );
};

export default FranchiseeComponent;
